import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {RouterModule, PreloadAllModules} from '@angular/router';
import {Routes} from './app.routes';
import {NoContentComponent} from './no-content/no-content.component';
import {NavigationComponent} from './navigation/navigation.component';
import {SmoothScrollToDirective, SmoothScrollDirective} from 'ng2-smooth-scroll';
import {ng2parallax} from './shared/parallax.directive';
import {WindowRefService} from './shared/window-ref-service.service';
import {MastheadComponent} from './masthead/masthead.component';
import {ServicesComponent} from './services/services.component';
import {PortfolioComponent} from './portfolio/portfolio.component';
import {TimelineComponent} from './timeline/timeline.component';
import {TeamComponent} from './team/team.component';
import {ContactComponent} from './contact/contact.component';
import {FooterComponent} from './footer/footer.component';
import {BrowserDetectorService} from './shared/browser-detector.service';
import {DataProviderService} from './shared/data-provider.service';
import {MemberCardComponent} from './team/member-card/member-card.component';
import {ServiceCardComponent} from './services/service-card/service-card.component';
import {TrustHtmlPipe} from './shared/trust-html.pipe';
import {ClientsComponent} from './clients/clients.component';
import {WowDirective} from './wow.directive';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HomeComponent} from './home/home.component';
import {Szechenyi2020Component} from './szechenyi2020/szechenyi2020.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    NoContentComponent,
    NavigationComponent,
    SmoothScrollToDirective,
    SmoothScrollDirective,
    ng2parallax,
    MastheadComponent,
    ServicesComponent,
    PortfolioComponent,
    TimelineComponent,
    TeamComponent,
    ContactComponent,
    FooterComponent,
    MemberCardComponent,
    ServiceCardComponent,
    TrustHtmlPipe,
    ClientsComponent,
    WowDirective,
    HomeComponent,
    Szechenyi2020Component
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(Routes, {
      useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    WindowRefService,
    BrowserDetectorService,
    DataProviderService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translateService: TranslateService) {
    translateService.setDefaultLang('en');
    translateService.use('en');
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/app.module.ts